import type {
    InfiniteScrollListFetchPage,
    InfiniteScrollListRemoteFieldPredicateOption,
} from '@/components/ui/infinite-scroll-list.types';
import { auditApi } from '@/lib/pillarApi';

export const ForensicOptionPageSize: number = 50;

export const fetchForensicUserOptionsPage: InfiniteScrollListFetchPage<
    InfiniteScrollListRemoteFieldPredicateOption,
    string
> = async (params) => {
    const response = await auditApi.listAuthorOptionsPage({
        limit: params.limit,
        ...(params.cursor !== undefined ? { cursor: params.cursor } : {}),
        ...(params.terms !== undefined ? { terms: [...params.terms] } : {}),
    });
    return {
        items: response.options,
        pagination: response.pagination,
    };
};

export const fetchForensicOrganizationOptionsPage: InfiniteScrollListFetchPage<
    InfiniteScrollListRemoteFieldPredicateOption,
    string
> = async (params) => {
    const response = await auditApi.listOrganizationOptionsPage({
        limit: params.limit,
        ...(params.cursor !== undefined ? { cursor: params.cursor } : {}),
        ...(params.terms !== undefined ? { terms: [...params.terms] } : {}),
    });
    return {
        items: response.options,
        pagination: response.pagination,
    };
};

export const fetchForensicSessionOptionsPage: InfiniteScrollListFetchPage<
    InfiniteScrollListRemoteFieldPredicateOption,
    string
> = async (params) => {
    const response = await auditApi.listSessionOptionsPage({
        limit: params.limit,
        ...(params.cursor !== undefined ? { cursor: params.cursor } : {}),
        ...(params.terms !== undefined ? { terms: [...params.terms] } : {}),
    });
    return {
        items: response.options.map((option) => ({
            value: option.value,
            label: option.label,
            secondaryLabel: `First: ${option.first_ts} · Latest: ${option.latest_ts}`,
        })),
        pagination: response.pagination,
    };
};
